export default {"src":"/_next/static/media/hu.98bd38f1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};